// MuiFabButtonSave.tsx
import React from 'react';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import Zoom from "@mui/material/Zoom";

interface MuiFabButtonAddProps {
    onClick: () => void;
    isDisabled?: boolean,
}

const MuiFabButtonSave: React.FC<MuiFabButtonAddProps> = ({onClick, isDisabled = false}) => {
    return (
        <Zoom in={true} unmountOnExit>
            <Fab color="primary" aria-label="add" onClick={onClick} variant="extended" disabled={isDisabled}>
                <SaveIcon style={{color: 'white'}}/>
            </Fab>
        </Zoom>
    );
};

export default MuiFabButtonSave;
